import { GeneratePOAButton } from "./GeneratePOAButton"

export default GeneratePOAButton
